import { useState, useRef } from "react";
import "./editorialForms.css";

export default function VideoBankForm({ data, onChange }) {
  const [tags, setTags] = useState(data?.tags?.join(", ") || "");
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onChange({ ...data, videoFile: file, videoFileName: file.name });
    }
  };

  const handleTagsChange = (e) => {
    const value = e.target.value;
    setTags(value);
    const tagsArray = value
      .split(",")
      .map((t) => t.trim())
      .filter((t) => t.length > 0);
    onChange({ ...data, tags: tagsArray });
  };

  const categories = [
    "Natureza",
    "Tecnologia",
    "Negocios",
    "Pessoas",
    "Animais",
    "Arquitetura",
    "Comida",
    "Esportes",
    "Viagem",
    "Abstrato",
    "Educacao",
    "Musica",
  ];

  const licenses = [
    { id: "free", name: "Gratuito" },
    { id: "commercial", name: "Comercial" },
    { id: "editorial", name: "Editorial" },
    { id: "creative_commons", name: "Creative Commons" },
  ];

  const resolutions = ["480p", "720p", "1080p", "2K", "4K", "8K"];

  return (
    <div className="editorial_form video_bank_form">
      <div className="editorial_form_section">
        <label>
          Vídeo <span className="required">*</span>
        </label>
        <div className="file_upload_area" onClick={() => fileInputRef.current?.click()}>
          <input
            ref={fileInputRef}
            type="file"
            accept="video/*,.mp4,.mov,.avi,.mkv,.webm"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          {data?.videoFileName ? (
            <div className="file_selected">
              <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" />
              </svg>
              <span>{data.videoFileName}</span>
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onChange({ ...data, videoFile: null, videoFileName: null });
                }}
                className="file_remove_btn"
              >
                ✕
              </button>
            </div>
          ) : (
            <div className="file_placeholder">
              <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
                <path d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z" />
              </svg>
              <p>Clique para fazer upload do vídeo</p>
              <span>MP4, MOV, AVI, MKV, WEBM</span>
            </div>
          )}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Titulo <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Titulo do video"
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
          maxLength={100}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descricao</label>
        <textarea
          placeholder="Descreva o conteudo do video..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={2000}
          rows={3}
        />
      </div>

      <div className="editorial_form_section">
        <label>Categoria</label>
        <div className="genre_chips">
          {categories.map((cat) => (
            <span
              key={cat}
              className={`genre_chip ${data?.category === cat ? "selected" : ""}`}
              onClick={() => onChange({ ...data, category: cat })}
            >
              {cat}
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Tags (separadas por virgula)</label>
        <input
          type="text"
          placeholder="natureza, paisagem, drone"
          value={tags}
          onChange={handleTagsChange}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Resolucao</label>
          <select
            value={data?.resolution || "1080p"}
            onChange={(e) => onChange({ ...data, resolution: e.target.value })}
          >
            {resolutions.map((res) => (
              <option key={res} value={res}>
                {res}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>FPS</label>
          <select
            value={data?.fps || 30}
            onChange={(e) => onChange({ ...data, fps: parseInt(e.target.value) })}
          >
            <option value={24}>24 fps</option>
            <option value={25}>25 fps</option>
            <option value={30}>30 fps</option>
            <option value={60}>60 fps</option>
            <option value={120}>120 fps</option>
          </select>
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Licenca</label>
        <select
          value={data?.license || "free"}
          onChange={(e) => onChange({ ...data, license: e.target.value })}
        >
          {licenses.map((lic) => (
            <option key={lic.id} value={lic.id}>
              {lic.name}
            </option>
          ))}
        </select>
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z" />
        </svg>
        <span>
          Adicione videos ao banco para que outros usuarios possam usar em seus
          projetos. Especifique a licenca corretamente.
        </span>
      </div>
    </div>
  );
}
